
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sa/prospectus-download",
      function () {
        return require("private-next-pages/sa/prospectus-download.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sa/prospectus-download"])
      });
    }
  